import React from "react";
import PageHeader, { PageCTA } from "../components/PageHeader";
import About from "../components/About";

export default function AboutPage() {
  return (
    <div data-testid="page-o-mnie">
      <PageHeader
        eyebrow="O mnie"
        title={
          <>
            Praktyk transportu,{" "}
            <span className="gold-gradient-text italic">nie teoretyk</span>
          </>
        }
        subtitle="Ponad 10 lat w branży transportowej i spedycyjnej. Budowałem, zarządzałem, naprawiałem. Dziś pomagam innym właścicielom firm podejmować lepsze decyzje."
      />
      <About />
      <PageCTA
        title="Chcesz porozmawiać o swojej sytuacji?"
        text="Zapraszam na bezpłatną, krótką rozmowę. Zobaczymy razem co można zrobić."
        buttonLabel="Umów rozmowę"
        to="/kontakt"
        secondary={{ to: "/oferta", label: "Zobacz ofertę" }}
      />
    </div>
  );
}
